import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApisService {

  public dashboardData: string = environment.apiUrl + '/dashboard';

  public smsSettings: string = environment.apiUrl + '/searchSettings';
  public sendSMS: string = environment.apiUrl + '/sendSMS';
  
  public users: string = environment.apiUrl + '/users';
  public searchUsers: string = environment.apiUrl + '/searchUsers';
  public addEditUser: string = environment.apiUrl + '/users';
  public deleteUser: string = environment.apiUrl + '/users';

  public categories: string = environment.apiUrl + '/categories';
  public searchCategory: string = environment.apiUrl + '/searchCategory';
  public addEditCategory: string = environment.apiUrl + '/categories';
  public deleteCategory: string = environment.apiUrl + '/categories';

  public topics: string = environment.apiUrl + '/topics';
  public searchTopics: string = environment.apiUrl + '/searchTopics';
  public addEditTopic: string = environment.apiUrl + '/topics';
  public deleteTopic: string = environment.apiUrl + '/topics';

  public questions: string = environment.apiUrl + '/questions';
  public searchQuestions: string = environment.apiUrl + '/searchQuestions';
  public addEditQuestion: string = environment.apiUrl + '/questions';
  public deleteQuestion: string = environment.apiUrl + '/questions';

  public locations: string = environment.apiUrl + '/locations';
  public searchLocations: string = environment.apiUrl + '/searchLocations';
  public addEditLocation: string = environment.apiUrl + '/locations';
  public deleteLocation: string = environment.apiUrl + '/locations';

  public clients: string = environment.apiUrl + '/clients';
  public searchClients: string = environment.apiUrl + '/searchClients';
  public addEditClient: string = environment.apiUrl + '/clients';
  public deleteClient: string = environment.apiUrl + '/clients';

  public employeeService:string = environment.apiUrl+'/v1/employees/employee';

  public projectService : string = environment.apiUrl+'/v1/projects/?pageNumber=0&pageSize=3&sortBy=name&sortDir=asc&q=data'

  constructor() { }
}


